import React, { Fragment } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import Translator from "Languages/Utility/Translator";
import NotificationTable from "./components/NotificationTable";

function Notifications() {
  return (
    <Fragment>
      <div className="page-top-title-button my-2">
        <PageTitle title={<Translator id="notification" />} />
      </div>
      <MuiPaper>
        <NotificationTable />
      </MuiPaper>
    </Fragment>
  );
}

export default Notifications;
